import React, { lazy } from "react";

const LazyData = lazy(() => import("./Data"));

const Data = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyData {...props} />;

export default Data;
